/**
 * Helpers for token bundle display. Bundles are fetched from the getTokenBundles Cloud Function.
 */

export interface TokenBundle {
  id: string;
  tokens: number;
  amountCents: number;
  label: string;
  detailLine: string;
}

export interface SubscriptionOption {
  tokensPerMonth: number;
  label: string;
  amountCents: number;
}

export function formatPrice(cents: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(cents / 100);
}

/**
 * Bonus credits for a bundle: tokens beyond what the base bundle rate would give.
 * Pass the first (smallest) bundle as baseBundle; it will show 0 bonus for that one.
 */
export function getBonusCredits(bundle: TokenBundle, baseBundle: TokenBundle): number {
  if (bundle.id === baseBundle.id) return 0;
  const tokensAtBaseRate = Math.floor(
    (bundle.amountCents / baseBundle.amountCents) * baseBundle.tokens
  );
  return Math.max(0, bundle.tokens - tokensAtBaseRate);
}
